import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import Dropdown from "../Components/Dropdown";
import Checkbox from "../Components/CheckBox";
import InputField from "../Components/InputField";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import {
  getTableNames,
  getOrganisations,
  getCompanyCodes,
  saveConfig,
  getColumnsByTable,
  saveFieldConfig,
  getTableConfig
} from "../Api/AuditService";
import { useAuth } from "../Context/AuthContext";
const AuditConfigForm = () => {
    const user = useAuth();
    const [columns, setColumns] = useState([]);
const [selectedColumns, setSelectedColumns] = useState([]);
const [showModal, setShowModal] = useState(false);
const [selectedColumn, setSelectedColumn] = useState(null);
const [isConfigExists, setIsConfigExists] = useState(false);
const [fieldConfig, setFieldConfig] = useState({
  isTracked: true,
  isKeyField: false,
  isSensitive: false,
  isMasked: false,
  trackOnInsert: true,
  trackOnUpdate: true,
  trackOnDelete: true,
  fieldClass: "",
  dataTypeName: "",
  displayName: "",
  active: true,
});
  const [form, setForm] = useState({
    isAuditEnabled: true,
    auditMode: "",
    retentionYears: 8,
    allowDelete: false,
    requireReasonOnUpdate: false,
    isImmutableAfterPosting: false,
    snapshotTableName: "",
    moduleName: "",
    active: true,
    createdBy: user?.userId?.toString() || "",
  });

  const [tables, setTables] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    const [tableData, orgData] = await Promise.all([
      getTableNames(),
      getOrganisations(),
    ]);
    setTables(tableData);
    setOrgs(orgData);
  };

  const handleOrgChange = async (e) => {
    const orgId = e.target.value;

    setForm({ ...form, orgScopeColumn: orgId, companyScopeColumn: "" });

    if (orgId) {
      const companies = await getCompanyCodes(orgId);
      setCompanies(companies);
    } else {
      setCompanies([]);
    }
  };
const openFieldModal = (col) => {
  setSelectedColumn(col);
  setShowModal(true);

  const formattedType = getFormattedDataType(col);

  setFieldConfig({
    isTracked: true,
    isKeyField: col.columN_NAME.toLowerCase().includes("id"), // smart default
    isSensitive: false,
    isMasked: col.datA_TYPE === "nvarchar" && col.characteR_MAXIMUM_LENGTH > 50,
    trackOnInsert: true,
    trackOnUpdate: true,
    trackOnDelete: true,
    fieldClass: "",
    dataTypeName: formattedType,
    displayName: col.columN_NAME,
    active: true,
  });
};
  const handleChange = (field) => (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    setForm({ ...form, [field]: value });
  };
const handleTableChange = async (e) => {
  const tableName = e.target.value;

  setForm((prev) => ({ ...prev, tableName }));

  if (tableName) {
    try {
      const [cols, config] = await Promise.all([
        getColumnsByTable(tableName),
        getTableConfig(tableName), // 🔥 call API
      ]);

      setColumns(cols);

      // 🔥 check if config exists
      const configData = Array.isArray(config) ? config[0] : config;

      if (configData) {
        setIsConfigExists(true);
      } else {
        setIsConfigExists(false);
      }
    } catch (err) {
      console.error(err);
      setIsConfigExists(false);
      toast.error("Error fetching table config");
    }
  } else {
    setColumns([]);
    setIsConfigExists(false);
  }
};
const handleColumnToggle = (columnName) => {
  setSelectedColumns((prev) =>
    prev.includes(columnName)
      ? prev.filter((c) => c !== columnName)
      : [...prev, columnName]
  );
};
  const handleSubmit = async(e) => {
    e.preventDefault();   
    try{ 
    const res=await saveConfig(form);
        console.log("Save response:", res);
        if(res){
            toast.success(`Configuration saved successfully! ID: ${res}`);
            setForm({
                tableName: "",
                isAuditEnabled: true,
                auditMode: "",
                retentionYears: 8,
                allowDelete: false,
                requireReasonOnUpdate: false,
                isImmutableAfterPosting: false,
                snapshotTableName: "",
                moduleName: "",
                orgScopeColumn: "",
                companyScopeColumn: "",
                active: true,
                createdBy: user?.userId?.toString() || "",
            });
        }
    } catch (error) {
        toast.error("Error saving configuration.");

    }
  };
const handleSaveFieldConfig = async () => {
  try {
    const payload = {
      tableName: form.tableName,
      columnName: selectedColumn.columN_NAME,
      orgScopeColumn:form.orgScopeColumn,
      companyScopeColumn:form.companyScopeColumn,
      createdBy: user?.userId?.toString() || "",
      dataTypeName: getFormattedDataType(selectedColumn),
      ...fieldConfig,
    };

    console.log("Field Payload:", payload);

    // call API here (create new API method)
    // await saveFieldConfig(payload);
    await saveFieldConfig(payload);

    toast.success("Field configuration saved!");
    setShowModal(false);
  } catch (err) {
    toast.error("Error saving field config");
  }
};
const getFormattedDataType = (col) => {
  const type = col.datA_TYPE?.toLowerCase();

  if (type === "nvarchar" || type === "varchar") {
    return `${type}(${col.characteR_MAXIMUM_LENGTH})`;
  }

  if (type === "int" || type === "decimal" || type === "numeric") {
    return `${type}(${col.numeriC_PRECISION},${col.numeriC_SCALE})`;
  }

  return type;
};
  return (
    <div className="container mt-4">
      <h3 className="mb-4 text-center">Audit Config Settings</h3>

      <Form onSubmit={handleSubmit}>
        {/* Row 1 */}
        <Row className="mb-3">
          <Col md={3}>
            <Dropdown
              label="Table Name"
              options={tables}
              value={form.tableName}
              onChange={handleTableChange}
              optionLabel="tableName"
              optionValue="tableName"
            />
          </Col>

      
            <Col md={3}>
            <Dropdown
              label="Organisation"
              options={orgs}
              value={form.orgScopeColumn}
              onChange={handleOrgChange}
              optionLabel="organisationName"
              optionValue="organisationId"
            />
          </Col>
             <Col md={3}>
            <Dropdown
              label="Company"
              options={companies}
              value={form.companyScopeColumn}
              onChange={handleChange("companyScopeColumn")}
              optionLabel="name"
              optionValue="companyCode"
            />
          </Col>
        </Row>

        {/* Row 3 */}
    
        {/* ================= Column Selection Section ================= */}
{columns.length > 0 && (
  <>
    <hr />
    <h5 className="mb-3">Fields Selection for Audit</h5>

  <Row>
  {columns.map((col, index) => (
    <Col md={3} key={index} className="mb-2">
      <div
        onClick={() => openFieldModal(col)}
        style={{
          cursor: "pointer",
          padding: "8px 12px",
          border: "1px solid #dee2e6",
          borderRadius: "6px",
          backgroundColor: "#f8f9fa",
          transition: "0.2s",
        }}
        className="hover-field"
      >
       {col.columN_NAME}{" "}
<small className="text-muted">
  ({getFormattedDataType(col)})
</small>
      </div>
    </Col>
  ))}
</Row>
   
  </>
)}
        {/* Submit */}
          <Row className="mb-3">
                <Col md={3}>
            <InputField
              label="Audit Mode"
              value={form.auditMode}
              onChange={handleChange("auditMode")}
            />
          </Col>
          <Col md={3}>
            <InputField
              label="Retention Years"
              type="number"
              value={form.retentionYears}
              onChange={handleChange("retentionYears")}
            />
          </Col>

          <Col md={3}>
            <InputField
              label="Module Name"
              value={form.moduleName}
              onChange={handleChange("moduleName")}
            />
          </Col>
           <Col md={3}>
            <InputField
              label="Snapshot Table Name"
              value={form.snapshotTableName}
              onChange={handleChange("snapshotTableName")}
            />
          </Col>
        </Row>
        {/* Checkboxes */}
        <Row className="mb-3">
          <Col md={2}>
            <Checkbox
              label="Is Audit Enabled"
              checked={form.isAuditEnabled}
              onChange={handleChange("isAuditEnabled")}
            />
          </Col>

          <Col md={2}>
            <Checkbox
              label="Allow Delete"
              checked={form.allowDelete}
              onChange={handleChange("allowDelete")}
            />
          </Col>

          <Col md={2}>
            <Checkbox
              label="Require Reason"
              checked={form.requireReasonOnUpdate}
              onChange={handleChange("requireReasonOnUpdate")}
            />
          </Col>

          <Col md={2}>
            <Checkbox
              label="Immutable After Posting"
              checked={form.isImmutableAfterPosting}
              onChange={handleChange("isImmutableAfterPosting")}
            />
          </Col>
             <Col md={2}>
            <Checkbox
              label="Active"
              checked={form.active}
              onChange={handleChange("active")}
            />
          </Col>
        </Row>
           <div className="text-center">
          <Button variant="primary" type="submit" disabled={isConfigExists}>
  Save Configuration
</Button>
        </div>
      </Form>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>
      Configure Field: {selectedColumn?.columN_NAME}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form>
      <Row className="mb-3">
        <Col md={6}>
          <InputField
            label="Display Name"
            value={fieldConfig.displayName}
            onChange={(e) =>
              setFieldConfig({ ...fieldConfig, displayName: e.target.value })
            }
          />
        </Col>

        <Col md={6}>
          <InputField
            label="Field Class"
            value={fieldConfig.fieldClass}
            onChange={(e) =>
              setFieldConfig({ ...fieldConfig, fieldClass: e.target.value })
            }
          />
        </Col>
      </Row>

      <Row className="mb-3">
       {["nvarchar", "varchar"].includes(selectedColumn?.datA_TYPE) && (
  <Col md={4}>
    <Checkbox
      label="Is Masked"
      checked={fieldConfig.isMasked}
      onChange={(e) =>
        setFieldConfig({ ...fieldConfig, isMasked: e.target.checked })
      }
    />
  </Col>
)}{["int", "decimal", "numeric"].includes(selectedColumn?.datA_TYPE) && (
  <Col md={6}>
    <Form.Text>
      Precision: {selectedColumn.numeriC_PRECISION} | Scale:{" "}
      {selectedColumn.numeriC_SCALE}
    </Form.Text>
  </Col>
)}{["nvarchar", "varchar"].includes(selectedColumn?.datA_TYPE) && (
  <Col md={6}>
    <Form.Text>
      Max Length: {selectedColumn.characteR_MAXIMUM_LENGTH}
    </Form.Text>
  </Col>
)}<InputField
  label="Field Class"
  value={fieldConfig.fieldClass}
  disabled={selectedColumn?.datA_TYPE === "bit"}
  onChange={(e) =>
    setFieldConfig({ ...fieldConfig, fieldClass: e.target.value })
  }
/>
      </Row>

      {/* Checkboxes */}
      <Row>
        <Col md={4}>
          <Checkbox
            label="Is Tracked"
            checked={fieldConfig.isTracked}
            onChange={(e) =>
              setFieldConfig({ ...fieldConfig, isTracked: e.target.checked })
            }
          />
        </Col>

        <Col md={4}>
          <Checkbox
            label="Is Key Field"
            checked={fieldConfig.isKeyField}
            onChange={(e) =>
              setFieldConfig({ ...fieldConfig, isKeyField: e.target.checked })
            }
          />
        </Col>

        <Col md={4}>
          <Checkbox
            label="Is Sensitive"
            checked={fieldConfig.isSensitive}
            onChange={(e) =>
              setFieldConfig({ ...fieldConfig, isSensitive: e.target.checked })
            }
          />
        </Col>

        <Col md={4}>
          <Checkbox
            label="Is Masked"
            checked={fieldConfig.isMasked}
            onChange={(e) =>
              setFieldConfig({ ...fieldConfig, isMasked: e.target.checked })
            }
          />
        </Col>

        <Col md={4}>
          <Checkbox
            label="Track Insert"
            checked={fieldConfig.trackOnInsert}
            onChange={(e) =>
              setFieldConfig({
                ...fieldConfig,
                trackOnInsert: e.target.checked,
              })
            }
          />
        </Col>

        <Col md={4}>
          <Checkbox
            label="Track Update"
            checked={fieldConfig.trackOnUpdate}
            onChange={(e) =>
              setFieldConfig({
                ...fieldConfig,
                trackOnUpdate: e.target.checked,
              })
            }
          />
        </Col>

        <Col md={4}>
          <Checkbox
            label="Track Delete"
            checked={fieldConfig.trackOnDelete}
            onChange={(e) =>
              setFieldConfig({
                ...fieldConfig,
                trackOnDelete: e.target.checked,
              })
            }
          />
        </Col>

        <Col md={4}>
          <Checkbox
            label="Active"
            checked={fieldConfig.active}
            onChange={(e) =>
              setFieldConfig({ ...fieldConfig, active: e.target.checked })
            }
          />
        </Col>
      </Row>
    </Form>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>
      Cancel
    </Button>

    <Button variant="primary" onClick={handleSaveFieldConfig}>
      Save Field Config
    </Button>
  </Modal.Footer>
   </Modal>
    </div>
  );
};

export default AuditConfigForm;